import { ComponentInterface, FunctionalComponent, h } from '@stencil/core';
import { VIMEO_REG_EX, YOUTUBE_REG_EX } from '../video.constants';
import { transformTagNames } from '../../../global/transform-tag-name';

interface PlayerProps {
  src: string;
  captions?: string;
  autoplay: boolean;
  status: string;
  pauseAriaLabel: string;
  playAriaLabel: string;
  togglePlay: () => void;
  bindVideoElement: (el: HTMLDivElement | HTMLVideoElement) => void;
  getVideoType: (src: string) => string;
}

const Player = (that: ComponentInterface): FunctionalComponent<PlayerProps> => {
  return ({ src, captions, autoplay, status, pauseAriaLabel, playAriaLabel, togglePlay, bindVideoElement, getVideoType }) => {
    const { WbRoundButton, WbIcon } = transformTagNames(that, 'wb-video', ['wb-round-button', 'wb-icon']);
    const isVimeoYoutube = src.match(VIMEO_REG_EX) || src.match(YOUTUBE_REG_EX);
    const provider = src.match(VIMEO_REG_EX) ? 'vimeo' : 'youtube';
    const isPlaying = status === 'playing';
    const ariaLabel = isPlaying ? pauseAriaLabel : playAriaLabel;
    const iconName = `${isPlaying ? 'pause' : 'media-play'}/24`;

    return (
      <div class={`player ${!isPlaying ? 'darken' : ''}`}>
        {isVimeoYoutube ? (
          <div ref={bindVideoElement} data-plyr-provider={provider} data-plyr-embed-id={src} />
        ) : (
          <video ref={bindVideoElement}>
            <source src={src} type={getVideoType(src)} />
            {captions && <track src={captions} default />}
          </video>
        )}
        {autoplay ? (
          <WbRoundButton class="toggle-autoplay" size="new-l" elevation="s" onClick={togglePlay} button-aria-label={ariaLabel}>
            <WbIcon name={iconName}></WbIcon>
          </WbRoundButton>
        ) : (
          <button class={`toggle-play ${!isPlaying ? 'visible' : ''}`} onClick={togglePlay} aria-label={ariaLabel}>
            <WbIcon name={iconName}></WbIcon>
          </button>
        )}
      </div>
    );
  };
};

export { Player as bindPlayer };
